import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FaArrowLeft, FaHome } from 'react-icons/fa';

const BackHomeNavigation = () => {
    const history = useHistory();

    return (
        <nav className="oi-history-nav" aria-label="Page navigation">
            <button
                type="button"
                className="oi-history-nav__button"
                onClick={() => history.goBack()}
                aria-label="Back"
                title="Back">
                <FaArrowLeft aria-hidden="true" />
            </button>
            <Link to="/dashboard" className="oi-history-nav__button" aria-label="Home" title="Home">
                <FaHome aria-hidden="true" />
            </Link>
        </nav>
    );
};

export default BackHomeNavigation;
